/**
 * 预加载图片
 * @param {string} imageUrl
 */
export async function preloadImage(imageUrl) {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.referrerPolicy = 'no-referrer'
    image.onload = resolve
    image.onerror = reject
    image.src = imageUrl
  })
}
